"use client";

/**
 * Lightweight “assembly” motif: geometric figures snap into place (CSS-only motion).
 * Keeps bundle small vs heavy canvas — still feels intentional on scroll.
 */
export function BlogAssemblingHero() {
  return (
    <div className="ed-blog-assemble" aria-hidden>
      <svg viewBox="0 0 320 120" className="ed-blog-assemble__svg">
        <defs>
          <linearGradient id="edAsmG" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#1db8c4" stopOpacity="0.95" />
            <stop offset="55%" stopColor="#0ea5e9" stopOpacity="0.85" />
            <stop offset="100%" stopColor="#6366f1" stopOpacity="0.5" />
          </linearGradient>
        </defs>
        <g className="ed-blog-assemble__piece ed-blog-assemble__piece--a">
          <rect x="8" y="28" width="56" height="56" rx="12" fill="url(#edAsmG)" opacity="0.92" />
        </g>
        <g className="ed-blog-assemble__piece ed-blog-assemble__piece--b">
          <circle cx="140" cy="56" r="28" fill="#0f172a" opacity="0.88" />
        </g>
        <g className="ed-blog-assemble__piece ed-blog-assemble__piece--c">
          <path d="M200 84 L248 36 L296 84 Z" fill="#22d3ee" opacity="0.72" />
        </g>
        <g className="ed-blog-assemble__piece ed-blog-assemble__piece--d">
          <rect x="228" y="62" width="84" height="36" rx="8" fill="#a5b4fc" opacity="0.4" />
        </g>
      </svg>
      <p className="ed-blog-assemble__caption">Scan · sync · shelf</p>
    </div>
  );
}
